import { DynamicContent } from 'ui/icons';

import { testIds } from '../../../constants';
import { useDynamicContentBuilderContext } from '../../../contexts/DynamicContentBuilderContext';
import { useTranslations } from '../../../hooks/useTranslations';
import { ToolbarButton } from './BaseInsertButton';

export const DynamicContentBuilderButton = () => {
  const { t } = useTranslations();
  const { toggle } = useDynamicContentBuilderContext();

  return (
    <ToolbarButton
      onClick={toggle}
      testId={testIds.toolbarBtnDynamicContentBuilder}
      tooltip={t('tooltip.buttonDynamicContentBuilder')}
    >
      <DynamicContent isColorInherited />
      <span>{t('button.dynamicContentBuilder')}</span>
    </ToolbarButton>
  );
};
